import React, { useMemo } from "react";
import { videoXMarkLight, videoXMarkSolid } from "../customIconDefinitions/VideoXMark";
import { faVideo } from "web-fortawesome/npm/pro-light";
import { faVideo as faVideoSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Video
 * @param props - props from interface IPresenceIconProps
 * @returns - the video icon
 */
export const PresenceIconVideo = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faVideoSolid;
			else
				return faVideo;
		} else if (props.callProtection) {
			if (props.type === "busy")
				return videoXMarkSolid;
			else
				return videoXMarkLight;
		}
		return faVideo;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
